import { Link } from 'react-router-dom';
import { config } from '../lib/config';
import { DayCheckinLogo } from './DayCheckinLogo';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-canvas border-t border-border-muted">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <DayCheckinLogo className="w-8 h-8" />
              <span className="text-xl font-semibold text-white">{config.siteName}</span>
            </div>
            <p className="text-text-secondary text-sm font-mono">
              Initialize your productivity.<br />
              Terminate distractions.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Systems</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#daily-workspace"
                  className="text-text-secondary hover:text-cyan transition-colors cursor-pointer text-sm"
                >
                  Daily Workspace
                </a>
              </li>
              <li>
                <a
                  href="#team-radar"
                  className="text-text-secondary hover:text-cyan transition-colors cursor-pointer text-sm"
                >
                  Team Radar
                </a>
              </li>
              <li>
                <a
                  href={config.appUrl}
                  className="text-text-secondary hover:text-cyan transition-colors cursor-pointer text-sm"
                >
                  Dashboard
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-text-secondary hover:text-cyan transition-colors cursor-pointer text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-text-secondary hover:text-cyan transition-colors cursor-pointer text-sm">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border-muted">
          <div className="text-sm text-text-dim font-mono">
            <p>
              SYS.COPYRIGHT // {currentYear} {config.siteName}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
